module.exports = __webpack_public_path__ + "a11bf42a5a66bafca58d8f2247624e3c.png";